import React,{ Component } from 'react';
import PropTypes from 'prop-types';
import { 
  Container, 
  Row, 
  Col, 
  Input, 
  FormGroup,
  Label 
} from 'reactstrap';

import Form from '../../../shared/components/Form';
import Button from '../../../shared/components/Button';
import MoneyInput from '../../../shared/components/MoneyInput';

import { formatPaymentMethod, delayPromiseChain, urlRoot } from '../../../shared/utils';

class AgencyAddFunds extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      isSubmitting:false,
      error:null,
      validationMessages:{}
    };
  }

  componentDidMount(){
    //TODO: Load data from server for AgencyAddFunds in componentDidMount
    Promise
      .all([])
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  handleSubmit(data){
    const validationMessages = {};

    this.setState({isSubmitting:true});

    if(!data.amount || data.amount === 0){
      validationMessages['amount'] = 'Amount is required';
    }

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages, isSubmitting:false});
      return;
    } else {
      this.setState({validationMessages:{}});
      //agencyId,paymentMethodId,amount
      this.props.addFundsToAgency(this.props.agencyId,data.paymentMethodId,data.amount)
        .then(() => delayPromiseChain(1000))
        .then(() => this.setState({isSubmitting:false}))
        .then(() => this.handleSuccess())
        .catch((err) => this.handleError(err))
    } 
  }

  handleSuccess(){
    this.props.history.push(`${urlRoot(this.props.match.url)}/account`)
  }

  handleSuccess(){
    const { history, match, redirectURL  } = this.props;
    
    if(redirectURL){
      history.push(redirectURL);
    } else {
      history.push(`${urlRoot(match.url)}/account`);
    }
  }

  handleError(err){}

  render(){
    //TODO: Render AgencyAddFunds
    return (
      <div className='AgencyAddFunds'>
        <Container>
          <Row className='EntityList-title'>
            <Col xs='6'>
              <h1>Add Funds</h1>
            </Col>
          </Row>
          <Row>
            <Col md='8' xs='12'>
              <Form onSubmit={(data) => this.handleSubmit(data)}>
                <MoneyInput 
                  name='amount'
                  label='Amount'
                  warning={this.state.validationMessages['amount']}
                />
                <FormGroup>
                  <Label>Payment Method</Label>
                  <Input 
                    type='select' 
                    name='paymentMethodId'
                  >
                    {this.props.activePaymentMethods.map((p) => (
                      <option key={p.id} value={p.is}>
                        {formatPaymentMethod(p)}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
                <Button 
                  isSubmit 
                  disabled={this.state.isSubmitting}
                >
                  {this.state.isSubmitting ? 'Submitting...' : 'Submit'}
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

AgencyAddFunds.propTypes = {
  //TODO: Fill in prop types for AgencyAddFunds
};

AgencyAddFunds.defaultProps = {
  //TODO: Fill in defaultProps for AgencyAddFunds
};

export default AgencyAddFunds;



// WEBPACK FOOTER //
// ./src/routes/AgencyAddFunds/components/AgencyAddFunds.js